import type { AxiosInstance } from 'axios';
import { getConfig } from '@petseo/shared';

export const BaseUrl = {
  addBaseUrlInterceptor(axiosInstance: AxiosInstance): void {
    axiosInstance.interceptors.request.use((config) => {
      config.baseURL = getConfig().petseoApiDomain;
      return config;
    });
  },
};

export default BaseUrl;
